// extracted by mini-css-extract-plugin
export default {"container":"Login_container__9pEUI","form":"Login_form__-eRSe","signup":"Login_signup__5Sf60","google":"Login_google__vIUJy"};